var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMultiply(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 7.995,
    viewBox: "0 0 8 7.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-multiply",
    d: "M14.5,6.97a.47.47,0,0,0-.328.145l-3.192,3.192L7.787,7.115a.47.47,0,1,0-.664.664l3.192,3.192L7.123,14.163a.47.47,0,1,0,.665.665l3.192-3.192,3.192,3.192a.47.47,0,1,0,.665-.665l-3.192-3.192,3.192-3.192A.47.47,0,0,0,14.5,6.97Z",
    transform: "translate(-6.981 -6.97)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMultiply);
export default __webpack_public_path__ + "static/media/iconMultiply.6865f7ac4b16199df3d7c69287737e05.svg";
export { ForwardRef as ReactComponent };